import { render } from "./AddCompany.vue?vue&type=template&id=6e17f545"
import script from "./AddCompany.vue?vue&type=script&lang=js"
export * from "./AddCompany.vue?vue&type=script&lang=js"
script.render = render

export default script